// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBNHwn1o3EsbqZXg_1GMaC6J9NOtAf_QZQ",
  authDomain: "calmi-rdw31.firebaseapp.com",
  projectId: "calmi-rdw31",
  storageBucket: "calmi-rdw31.firebasestorage.app",
  messagingSenderId: "415330152865",
  appId: "1:415330152865:web:e2e1024d9836ba6abd9be0"
};

// Initialize Firebase
console.log('[FIREBASE] Inicializando Firebase con config:', firebaseConfig.projectId);
const app = initializeApp(firebaseConfig);
console.log('[FIREBASE] Firebase inicializado correctamente');

// Initialize Firebase services
export const auth = getAuth(app);
console.log('[FIREBASE] Auth inicializado');

// Configurar persistencia local para que la sesión dure 30 días
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('[FIREBASE] Persistencia local configurada (30 días)');
  })
  .catch((error) => {
    console.error('[FIREBASE] Error al configurar persistencia:', error);
  });

export const db = getFirestore(app);
console.log('[FIREBASE] Firestore inicializado');

export const storage = getStorage(app);
console.log('[FIREBASE] Storage inicializado');

export default app;
